import { TaskChooseOrganization } from '@clerk/react';

import { AppRoutes } from '@/utils/routes/router';

/**
 * Clerk org session task UI (no layout chrome).
 * Prefer this over letting <SignIn>/<SignUp> path-route `/tasks/choose-organization`,
 * which can spin forever when the session task doesn't match the host component.
 *
 * `redirectUrlComplete` is required — without it Clerk may bounce to a wrong task URL
 * after org create (empty card: "cannot render unless a session task is pending").
 */
export default function ClerkChooseOrganizationTask() {
  return (
    <div className="flex w-full flex-col items-center justify-center px-4 py-8">
      <p className="mb-6 max-w-md text-center text-sm text-custom-darkSilver">
        Choose or create an organization to continue. Each organization maps to one ChurnSignal tenant.
      </p>
      <TaskChooseOrganization redirectUrlComplete={AppRoutes.dashboard} />
    </div>
  );
}
